/*
 * Triple Y — מונה הסכמה  (ty-consent-metrics)
 * ============================================
 * מטרה אחת: לענות על "כמה אחוז מהגולשים מאשרים את הבאנר".
 *
 * הוא מסמן כל ישיבה בתגית Clarity אחת, `ty_consent`, שערכה הוא המצב
 * שמחזירה `TripleYConsent.state()`. אחר כך סופרים בלוח של Clarity.
 *
 * 🔴 זו מדידה זמנית. אחרי שבוע יש מספר, ואפשר להסיר את השורה
 *    מ-layout/theme.liquid. הכלי apply-consent-metrics מסיר אותה ב---rollback.
 *
 * ── למה Clarity ולא מקום אחר, ונמדד ולא הונח ──────────────────────
 *   · אין לנו שום שרת. כל אפליקציות השופיפיי הן extension בלבד,
 *     ו-application_url שלהן הוא דמה. אין נקודת קצה לשלוח אליה.
 *   · שופיפיי סופרת אך ורק מי שאישר, ולכן היא לא יכולה למדוד את עצמה.
 *   · Clarity נטען לכל גולש, לפני הכרעה וגם אחרי סירוב. נמדד 09.09.2026
 *     בשלושה תרחישים בדפדפן.
 *   · window.clarity הוא function בהקשר הדף הראשי. נמדד. אילו הוא היה
 *     מותקן כ-Web Pixel הוא היה יושב בארגז חול והקריאה הזו לא הייתה עובדת.
 *
 * ⚠️ התגית אינה מידע אישי חדש. Clarity כבר מקליט את הישיבה במלואה,
 *    וזו מחרוזת אחת מתוך שש. **הפער שהיא מודדת הוא בדיוק הפער שצריך לסגור.**
 *
 * ── איך סופרים בלוח של Clarity ────────────────────────────────────
 *   ישיבה שנושאת `accepted`                      ⟵ אישר
 *   ישיבה שנושאת `declined` ואין בה `accepted`   ⟵ סירב
 *   ישיבה שנושאת `undeclared` בלבד               ⟵ לא הכריע
 *
 * 🔴 ישיבה יכולה לשאת שתי תגיות, וזה מכוון. מי שנחת בלי הכרעה ואז אישר
 *    מסומן גם `undeclared` וגם `accepted`. **הסדר שלמעלה הוא מה שמכריע**,
 *    ולכן "יש accepted" נבדק ראשון.
 */
(function () {
  'use strict';

  var VERSION = '1.0.0';
  var TAG_KEY = 'ty_consent';
  var STORE_KEY = 'ty_consent_metric_sent';

  var MAX_TRIES = 60;          // 60 × 250ms = 15 שניות
  var TICK_MS = 250;

  var sent = [];               // מה נשלח בפועל, לרתמת הבדיקות
  var tries = 0;

  function log() {
    if (!window.TY_CONSENT_METRICS_DEBUG) return;
    try { console.log.apply(console, ['[ty-consent-metrics]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* מה כבר נשלח בישיבה הזו. אחסון חסום אינו שגיאה, פשוט נשלח שוב. */
  function alreadySent(value) {
    if (sent.indexOf(value) !== -1) return true;
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY) || '';
      return raw.split(',').indexOf(value) !== -1;
    } catch (e) { return false; }
  }

  function remember(value) {
    sent.push(value);
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY) || '';
      window.sessionStorage.setItem(STORE_KEY, raw ? raw + ',' + value : value);
    } catch (e) {}
  }

  /* 🔴 המדד הוא שהקריאה יצאה, ולא ש-window.clarity קיים.
     clarity שנטען אך טרם אותחל זורק, ולכן הכל בתוך try. */
  function tag(value) {
    if (typeof window.clarity !== 'function') return false;
    try {
      window.clarity('set', TAG_KEY, value);
      return true;
    } catch (e) {
      log('clarity זרק', e);
      return false;
    }
  }

  function report(value) {
    if (!value) return false;
    if (alreadySent(value)) { log('כבר נשלח בישיבה הזו', value); return true; }
    if (!tag(value)) return false;
    remember(value);
    log('נשלח', value);
    return true;
  }

  /* המצב הנוכחי, או null כשעוד אי אפשר להכריע. */
  function currentState() {
    if (!window.TripleYConsent || typeof window.TripleYConsent.state !== 'function') return null;
    var s;
    try { s = window.TripleYConsent.state(); } catch (e) { return null; }
    if (s === 'loading') return null;       // ה-API עוד לא ענה, אין מה לדווח
    return s;
  }

  /* מנסה לדווח עד שגם המצב ידוע וגם clarity ענה. */
  function attempt() {
    var s = currentState();
    if (s && report(s)) return;              // הצליח
    if (++tries > MAX_TRIES) {
      log('ויתרתי. מצב:', s, '· clarity:', typeof window.clarity);
      return;
    }
    setTimeout(attempt, TICK_MS);
  }

  /* שינוי הסכמה: מדווח את המצב החדש, בנוסף למה שכבר דווח. */
  document.addEventListener('visitorConsentCollected', function () {
    /* המצב מתעדכן באותו אירוע, ולכן קריאה מיידית תקינה.
       בכל זאת ניסיון חוזר, כי clarity עלול עוד לא להיות מוכן. */
    var t = 0;
    (function retry() {
      var s = currentState();
      if (s && report(s)) return;
      if (++t > 20) return;
      setTimeout(retry, TICK_MS);
    })();
  });

  attempt();

  /* לרתמת הבדיקות בלבד. */
  window.TripleYConsentMetrics = {
    VERSION: VERSION,
    TAG_KEY: TAG_KEY,
    sent: function () { return sent.slice(); },
    state: currentState,
    /** מאלץ דיווח מחדש, לבדיקה. */
    _force: function (v) { return tag(v); }
  };
})();
